import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AdmissionService } from 'src/app/private/services/admission.service';
import { EnrollmentService } from 'src/app/private/services/enrollment.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-bulk-delete-admission',
  imports: [SharedModule],
  templateUrl: './bulk-delete-admission.component.html',
  styleUrl: './bulk-delete-admission.component.scss'
})
export class BulkDeleteAdmissionComponent {


  @Output() closeDialog = new EventEmitter();
  @Input() selectedProducts: any[] = [];
  @Output() reload = new EventEmitter<any>();
  isLoading = false;

  constructor(
    private localStorage: LocalStorageService,
    private api: AdmissionService,
    private messageService: MessageService

  ) { }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  ngOnInit() {
    // remove Moved status from selected products if exists
    this.selectedProducts = this.selectedProducts.filter(item => item.admission_status !== 'Converted');
  }

  handleDelete() {


    const payload = {
      admission_ids: this.selectedProducts.map(item => item.admission_id),
      organization_id: this.localStorage.getOrganizationId()
    };

    this.isLoading = true;
    this.api.bulkDeleteAdmission(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.closeDialog.emit();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: response.message
        });
      },
      error: (error) => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.error.message
        });
      }

    }
    );
  }
}
